import React from "react";
import { useSettings } from "../lib/settings-context";
import { buildWhatsAppUrl } from "../lib/whatsapp";
import { reportWhatsAppClick } from "../lib/whatsapp-beacon";
import WhatsAppIcon from "./WhatsAppIcon";

/**
 * Action-bar variant of the WhatsApp CTA. Green outline + inline SVG glyph.
 * Used on order + shipment confirmation pages next to the PDF download.
 */
export default function WhatsAppActionButton({
  kind, // "pedido" | "envio"
  shortId,
  orderId,
  shipmentId,
  testId = "whatsapp-action-btn",
}) {
  const { whatsappNumber, whatsappFloatingEnabled } = useSettings();
  if (!whatsappFloatingEnabled) return null;

  const prefill =
    kind === "envio"
      ? `Hola MercaGo, tengo una consulta sobre el envío ${shortId}`
      : `Hola MercaGo, tengo una consulta sobre el pedido ${shortId}`;
  const href = buildWhatsAppUrl(whatsappNumber, prefill);

  const onClick = () => {
    reportWhatsAppClick("confirmation_action", {
      order_id: orderId,
      shipment_id: shipmentId,
    });
  };

  return (
    <a
      data-testid={testId}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className="inline-flex items-center gap-2 rounded-full border-2 border-[#25D366] text-[#0b6b2e] hover:bg-[#25D366] hover:text-white px-4 py-2 text-sm font-semibold transition-colors"
    >
      <WhatsAppIcon className="h-4 w-4" />
      Abrir chat de WhatsApp
    </a>
  );
}
